import React from "react";
import PropTypes from "prop-types";
import useElementSize from "../hooks/use-element-size";
import { PILL_BORDER_DEFAULTS } from "./pill-border-utils";
import useAccessibilityContext from "../accessibility/store/use-accessibility-context";

const DashedLine = ({
  dash = "60 2 15 17",
  dashOffset = PILL_BORDER_DEFAULTS.dashOffset,
  strokeWidth = PILL_BORDER_DEFAULTS.strokeWidth,
}) => {
  const { simpleDesign = false } = useAccessibilityContext() || {};
  const [ref, { width: W }] = useElementSize();

  return (
    <span
      ref={ref}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 0,
        pointerEvents: "none",
        zIndex: 0,
      }}
      className="dashed-line"
      aria-hidden="true"
    >
      {W > 0 && (
        <svg
          width={W}
          height={strokeWidth}
          style={{ position: "absolute", top: 0, left: 0, overflow: "visible" }}
          aria-hidden="true"
        >
          <line
            x1={strokeWidth / 2}
            y1={strokeWidth / 2}
            x2={W - strokeWidth / 2}
            y2={strokeWidth / 2}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
            {...(!simpleDesign && { strokeDasharray: dash, strokeDashoffset: dashOffset })}
          />
        </svg>
      )}
    </span>
  );
};

DashedLine.propTypes = {
  dash: PropTypes.string,
  dashOffset: PropTypes.number,
  strokeWidth: PropTypes.number,
};

export default DashedLine;
